<template>
  <div>
    <div class="row">
      <div class="col-lg-6 col-sm-12 d-flex justify-content-start">
        <vx-card title="Mi empresa" :subtitle="empresa.fantasia" class="mr-2" v-if="empresa">
          <vs-row>
            <vs-col vs-w="3">Empresa</vs-col>
            <vs-col vs-w="9" style="font-weight: bolder;">{{ empresa.fantasia }}</vs-col>
            <vs-col vs-w="3">RUT</vs-col>
            <vs-col vs-w="9" style="font-weight: bolder;">{{ empresa.iut }}</vs-col>
            <vs-col vs-w="3" class="mt-3">Usuario</vs-col>
            <vs-col vs-w="9" class="mt-3">{{ usuario.alias }}</vs-col>
          </vs-row>
        </vx-card>
      </div>
      <div
        class="col-lg-6 col-sm-12 d-flex justify-content-center"
        :class="{'mt-5': product === 'aprobacionesApp'}"
      >
        <vx-card title="Mis módulos" :class="{'ml-2': product !== 'aprobacionesApp'}">
          <div class="container">
            <div class="centrador">
              <CheckPermission
                data-cy="module"
                :key="module.nombre"
                class="modulo mr-5 mt-5 pt-5"
                v-for="module in enabledModules"
                :permission="module.permission"
              >
                <div
                  v-on:click="selectAndNavigateModule(module)"
                >
                  <div class="nombre-modulo">{{ module.descripcion }}</div>
                  <vs-icon :icon="module.icono" size="75px" color="#ffffff" class="mt-2"></vs-icon>
                  <vs-icon
                    icon="star"
                    size="20px"
                    color="#ffffff"
                    class="modulo-actual"
                    v-if="module.nombre === moduloActual"

                  />
                </div>
              </CheckPermission>
              <CheckPermission
                class="modulo modulo-deshabilitado mr-5 mt-5 pt-5"
                v-for="module in disabledModules"
                :key="module.nombre"
                :permission="module.permission"
              >
                <div class="nombre-modulo">{{ module.descripcion }}</div>
                <vs-icon :icon="module.icono" size="75px" color="#ffffff" class="mt-2"></vs-icon>
              </CheckPermission>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <b-modal
      size="lg"
      title="Información importante"
      ref="comunicado"
      no-close-on-backdrop
      hide-footer
      hide-header-close
    >
      <Comunicado @close-comunicado="closeComunicado" />
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import ModuleSettingsMixin from '@/febos/global/inicio/mixins/ModuleSettingsMixin';

export default {
  data() {
    return {
      product: process.env.VUE_APP_PRODUCTO
    };
  },
  mixins: [ModuleSettingsMixin],
  components: { CheckPermission },
  computed: {
    ...mapGetters('Usuario', { usuario: 'currentUser', hasPermission: 'hasPermission' }),
    ...mapGetters({ moduloActual: 'currentModule' }),
    ...mapGetters('Empresas', { empresa: 'company' }),
    ...mapGetters('Inicio', ['globalIndicators', 'personalIndicators']),
    enabledModules() {
      return this.modules.filter((module) => {
        const isSaval = this.empresa.iut === '91650000-9';
        if (isSaval) {
          return module.visible && module.habilitado && module.nombre !== 'expedientesEd';
        }
        return module.visible && module.habilitado;
      });
    },
    disabledModules() {
      return this.modules.filter((module) => module.visible && !module.habilitado);
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Menus', { seleccionarModulo: 'seleccionarModulo' }),
    ...mapActions('Usuario', ['loadPermissions']),
    selectAndNavigateModule(module) {
      if (module.route && module.route.name) {
        this.$router.push({ ...module.route });
      } else {
        this.$router.push({ name: module.route });
      }
      this.seleccionarModulo(module.nombre);
    },
    searchAndSelectModule() {
      const modules = this.enabledModules.filter((module) => this.hasPermission(module.permission));
      if (modules && modules.length === 1) {
        this.selectAndNavigateModule(modules[0]);
      }
    },
    closeComunicado() {
      this.$refs.comunicado.hide();
      localStorage.setItem('comunicado-leido', true);
    }
  },
  created() {
    this.closeModal();
    this.loadPermissions();
    this.searchAndSelectModule();
  },
};
</script>

<style lang="css" scoped>
.modulo {
  width: 165px;
  height: 130px;
  border: 1px solid #ccc;
  display: inline-block;
  vertical-align: bottom;
  border-radius: 10px;
  box-shadow: 3px 3px 10px #ccc;
  color: white;
  font-size: 90%;
  background-color: rgb(var(--vs-primary));

}

.modulo:hover {
  box-shadow: 3px 3px 10px #aaa;
  cursor: pointer;
  text-shadow: 3px 3px 10px #fff;
}

.container {
  text-align: center;
}

.centrador {
  margin: auto;
}

.nombre-modulo {
  font-weight: bold;
}

.modulo-deshabilitado {
  background-color: #ccc !important;
}

.modulo-deshabilitado:hover {
  background-color: #ccc !important;
  box-shadow: 3px 3px 10px #ccc;
  cursor: default;
  text-shadow: none !important;
}

.modulo-actual {
  position: relative;
  right: -20px;
  bottom: -5px;
}
</style>
